// extracted by mini-css-extract-plugin
module.exports = {"hasDiscount":"ss","isSRPPage":"st","blue":"su","red":"sv","yellow":"sw","violet":"sx","orange":"sy","gold":"sz","stroke_black":"sA","stroke_green":"sB","stroke_white":"sC"};